import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined

export function initSentry() {
  if (!dsn) return
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
    allowUrls: [/https?:\/\/whistlesports\.app/],
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Network request failed',
      'NetworkError',
      'Failed to fetch',
      'Load failed',
    ],
  })
}

export function setSentryUser(id: string, email?: string) {
  if (!dsn) return
  Sentry.setUser({ id, email })
}

export function clearSentryUser() {
  if (!dsn) return
  Sentry.setUser(null)
}

export { Sentry }
export const SentryErrorBoundary = Sentry.ErrorBoundary
